export const packageList = [
  {
    name: 'sys',
    activeRule: ['ams', 'mcs'],
  },
  {
    name: 'bss_common',
    activeRule: []
  },
  {
    name: 'bss_uamp',
    activeRule: ['uamp']
  },
  {
    name: 'bss_inform_center',
    activeRule: ['inform-center']
  },
  {
    name: 'bss_flow',
    activeRule: []
  },
  {
    name: 'bss',
    activeRule: ['bss'], // 组件平台
  },
  {
    name: 'devops_flow',
    activeRule: []
  },
  {
    name: 'bss_opa',
    activeRule: ['opa']
  },
  {
    name: 'bss_config',
    activeRule: ['bss-config']
  },
]
export const remoteModuleConfig = {
  dev: ['sys', 'bss_common', 'bss_uamp', 'bss_inform_center', 'bss_flow', 'bss_opa', 'bss', 'devops_flow', 'bss_config'],
  stg: ['sys', 'bss_common', 'bss_uamp', 'bss_inform_center', 'bss_flow', 'bss_opa', 'bss', 'devops_flow', 'bss_config'],
  uat: ['sys', 'bss_common', 'bss_uamp', 'bss_inform_center', 'bss_flow', 'bss_opa', 'bss', 'devops_flow', 'bss_config'],
  prd: ['sys', 'bss_common', 'bss', 'devops_flow'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/sys/index.js